const DB_NAME = 'website-builder-media';
const DB_VERSION = 1;
const HERO_VIDEO_STORE = 'hero-videos';

function openWebsiteBuilderMediaDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(HERO_VIDEO_STORE)) {
        db.createObjectStore(HERO_VIDEO_STORE);
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () =>
      reject(request.error ?? new Error('Failed to open IndexedDB'));
  });
}

export async function saveHeroVideoBlob(blob: Blob): Promise<string> {
  const db = await openWebsiteBuilderMediaDb();
  const id = `hero-video-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(HERO_VIDEO_STORE, 'readwrite');
    const store = tx.objectStore(HERO_VIDEO_STORE);
    store.put(blob, id);
    tx.oncomplete = () => resolve();
    tx.onerror = () =>
      reject(tx.error ?? new Error('Failed to save hero video blob'));
    tx.onabort = () => reject(new Error('Saving hero video blob was aborted'));
  });

  db.close();
  return id;
}

export async function loadHeroVideoBlob(id: string): Promise<Blob | null> {
  const db = await openWebsiteBuilderMediaDb();

  const blob = await new Promise<Blob | null>((resolve, reject) => {
    const tx = db.transaction(HERO_VIDEO_STORE, 'readonly');
    const store = tx.objectStore(HERO_VIDEO_STORE);
    const req = store.get(id);
    req.onsuccess = () => {
      const result: unknown = req.result;
      resolve(result instanceof Blob ? result : null);
    };
    req.onerror = () =>
      reject(req.error ?? new Error('Failed to load hero video blob'));
  });

  db.close();
  return blob;
}

export async function deleteHeroVideoBlob(id: string): Promise<void> {
  const db = await openWebsiteBuilderMediaDb();

  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(HERO_VIDEO_STORE, 'readwrite');
    const store = tx.objectStore(HERO_VIDEO_STORE);
    store.delete(id);
    tx.oncomplete = () => resolve();
    tx.onerror = () =>
      reject(tx.error ?? new Error('Failed to delete hero video blob'));
    tx.onabort = () =>
      reject(new Error('Deleting hero video blob was aborted'));
  });

  db.close();
}

export async function clearHeroVideoBlobs(): Promise<void> {
  const db = await openWebsiteBuilderMediaDb();

  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(HERO_VIDEO_STORE, 'readwrite');
    const store = tx.objectStore(HERO_VIDEO_STORE);
    store.clear();
    tx.oncomplete = () => resolve();
    tx.onerror = () =>
      reject(tx.error ?? new Error('Failed to clear hero video blobs'));
    tx.onabort = () =>
      reject(new Error('Clearing hero video blobs was aborted'));
  });

  db.close();
}
